import { makeAutoObservable, runInAction } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export default class BusinessStore {
	constructor() {
		makeAutoObservable(this);
		makePersistable(this, {
			name: 'BusinessStore',
			properties: [
				'signedUpBusinesses',
				'signedUpBusinessesTotalCount',
				'singleSignedUpBusinesses',
				'businessCategories',
				'businessCategoriesTotalCount',
				'updatedBusinessStatus',
				'signedupBusinessesAnalysis',
			],
		});
	}

  	signedUpBusinesses = [];
	signedUpBusinessesTotalCount = 0;
	singleSignedUpBusinesses = {}
  	businessCategories = [];
	businessCategoriesTotalCount = 0;
	updatedBusinessStatus = {};
	signedupBusinessesAnalysis = [];

	reset = () => {
		this.signedUpBusinesses = [];
		this.signedUpBusinessesTotalCount = 0;
		this.singleSignedUpBusinesses = {};
		this.businessCategories = [];
		this.businessCategoriesTotalCount = 0;
		this.updatedBusinessStatus = {};
		this.signedupBusinessesAnalysis = [];
	};

	setSignedUpBusinesses = async businesses => {
		runInAction(() => {
			this.signedUpBusinesses = businesses;
		});
	};

	setSignedUpBusinessesTotalCounts = async count => {
		runInAction(() => {
			this.signedUpBusinessesTotalCount = count;
		});
	};

	setSingleSignedUpBusinesses = async business => {
		runInAction(() => {
			this.singleSignedUpBusinesses = business;
		});
	};

	setBusinessCategories = async businessCategories => {
		runInAction(() => {
			this.businessCategories = businessCategories;
		});
	};

	setBusinessCategoriesTotalCount = async counts => {
		runInAction(() => {
			this.businessCategoriesTotalCount = counts;
		});
	};

	setUpdatedBusinessStatus = async business => {
		runInAction(() => {
			this.updatedBusinessStatus = business;
		});
	};

	setSignedupBusinessesAnalysis = async state => {
		runInAction(() => {
			this.signedupBusinessesAnalysis = state;
		});
	};
}